var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMesg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.30249V19.5C30.0001 20.6478 29.5615 21.7523 28.7741 22.5874C27.9866 23.4225 26.9098 23.9252 25.764 23.9925L25.5 24H4.5C3.35218 24.0001 2.24773 23.5615 1.41261 22.7741C0.57749 21.9866 0.0748387 20.9098 0.00750017 19.764L0 19.5V5.30249L14.1675 14.748L14.3415 14.847C14.5466 14.9472 14.7718 14.9993 15 14.9993C15.2282 14.9993 15.4534 14.9472 15.6585 14.847L15.8325 14.748L30 5.30249Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0C27.12 0 28.5405 0.855 29.3325 2.1405L15 11.6955L0.66748 2.1405C1.04367 1.52973 1.56042 1.01775 2.17464 0.647234C2.78886 0.276718 3.48276 0.0584059 4.19848 0.0105L4.49998 0H25.5Z",
    fill: "#4987FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesg);
export default __webpack_public_path__ + "static/media/Mesg.94d2b9026550da7cde56d7e39693dc81.svg";
export { ForwardRef as ReactComponent };